module.exports = __webpack_public_path__ + "assets/img/9.bcba9e8a.png";